export default "__VITE_ASSET__17eeedd0__"